module.exports = __webpack_public_path__ + "static/media/Eagle319_4c2.2a57ac7d.svg";